import { FilterEntry, Filters } from "@/lib/filters/types";

/**
 * Merges two filter arrays, deduplicating by columnId + filterType.
 * Options filters take precedence over default filters.
 */
export const mergeFilters = <T>(
  defaultFilters: Filters<T> = [],
  optionsFilters: Filters<T> = [],
): Filters<T> => {
  const getKey = (entry: FilterEntry) =>
    `${String(entry.id)}:${entry.value.filter}`;

  const optionsKeys = new Set(optionsFilters.map(getKey));

  // Keep default filters that don't have a matching (id + filterType) in options
  const filteredDefaults = defaultFilters.filter(
    (entry) => !optionsKeys.has(getKey(entry)),
  );

  return [...filteredDefaults, ...optionsFilters];
};
